import { Controller } from '@hotwired/stimulus';

// Onglets Bootstrap 3 : classe `active` sur le `li` de
// l'onglet et sur le `.tab-pane` que son lien vise par `href="#id"` (le CSS
// n'affiche que `.tab-content > .active`), `aria-selected` sur les liens.
//
// Actions attendues : `tabs#select` sur chaque lien d'onglet ; cibles `tab`
// (les `li`) et `pane` (les `.tab-pane`).
export default class TabsController extends Controller<HTMLElement> {
  static targets = ['tab', 'pane'];

  declare readonly tabTargets: HTMLElement[];

  declare readonly paneTargets: HTMLElement[];

  select(event: Event): void {
    event.preventDefault();

    const link = event.currentTarget as HTMLAnchorElement;
    const tab = link.closest('li');
    const paneId = link.getAttribute('href')?.replace(/^#/, '');

    this.tabTargets.forEach((candidate) => {
      const selected = candidate === tab;

      candidate.classList.toggle('active', selected);
      candidate
        .querySelector('a')
        ?.setAttribute('aria-selected', String(selected));
    });

    this.paneTargets.forEach((pane) => {
      pane.classList.toggle('active', pane.id === paneId);
    });
  }
}
